<div class="travel-vip-success-container">
  <div class="success-card">
    <!-- Hand holding phone illustration, overflowing the card top -->
    <div class="hand-illustration">
      <img
        [src]="successImage"
        alt="{{ 'login.jsp.activation_success_message' | translate }}"
        class="hand-image"
      />
    </div>

    <!-- TRAVEL VIP branding: partner logo when available, text fallback -->
    <div class="brand-section">
      <img
        *ngIf="appLogo; else brandText"
        [src]="appLogo"
        alt="Travel VIP"
        class="brand-logo"
      />
      <ng-template #brandText>
        <span class="brand-name">
          <span class="brand-travel">TRAVEL</span>
          <span class="brand-vip">VIP</span>
        </span>
      </ng-template>
    </div>

    <!-- Activation success message -->
    <p class="success-message">
      {{ 'login.jsp.activation_success_message' | translate }}
    </p>

    <!-- CTA -->
    <div class="action-section">
      <button class="access-benefits-btn" (click)="onAccessBenefits()">
        <span class="btn-text">{{ 'login.jsp.access_benefits' | translate }}</span>
        <ion-icon name="arrow-forward" class="arrow-icon"></ion-icon>
      </button>
    </div>
  </div>
</div>
